<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import Cent2 from '@/views/review/cent2.vue'
export default {
    components:{
        Cent2
    },
    props: {
        params: {
            type: Object,
            default: () => {}
        },
        // check: 审核台详情
        type: String
    },
    data() {
        return {
            info: {
                check_info:{},
                works_info:{}
            },
            activeName: 'works',
            contracts: [],
            examineState: {"0": "待审核", "1": "审核通过", "-1": "已驳回", "-2": "已失效或撤回", "-3": "已回退"},
            examines: {
                0: '视觉审核' ,
                1: '价格确认' ,
                2: '价格审批'
            },
            cent_list:[]
        };
    },
    filters: {
        load_status(val) {
            switch(val) {
                case '1':
                    return '邀稿中'
                case '2':
                    return '完成交稿'
                case '-1':
                    return '放弃交稿'
                default:
                    // 默认代码块
            } 
        }
    },
    methods: {
        init() {
            this.photoworkReviewInfo() //换成这个
        },
        async init_channel_fileRecords() {
            let data = await this.api.channel_fileRecords(Object.assign({ channel_id: this.info.check_info.check_detail[0].channel_id }, this.params))
            this.cent_list = data.data
            this.cent_list.forEach((val)=>{
                if(val.check_status == '1'){
                    this.$store.commit("common_vuex/set_file_data",val)
                }
            })
        },
        async getContractList() {
            let { type } = this.params
            let apiName = 'getPhotoworkContractList'

            if(type === 9) {
                apiName = 'getContributionworkContractList'
            }

            let data = await this.api[apiName](Object.assign({ type: 8 }, this.params))

            this.contracts = data
        },
        async photoworkReviewInfo() {
            let data = await this.api.review_info({ type: 10 ,id:this.params.id})
            this.info.check_info = data.check_info
            this.info.works_info = data.works_info
            this.init_channel_fileRecords()
            this.$forceUpdate()
        },
    },
    computed: {
        examineItem() {
            let type = this.params.type
            let name = '摄影投稿'

            if(type === 9) {
                name = '作品投稿'
            }
            if(type === 10) {
                name = '渠道分发'
            }

            return name
        },
        step() {
            let type = this.params.type
            let step = {
                0: '视觉审核' ,
                1: '价格确认' ,
                2: '价格审批'
            }

            if(type === 9) {
                step = {
                    0: '视觉审核',
                    1: '稿件检查',
                    2: '价格确认',
                    3: '价格审批',
                }
            }
            if(type === 10) {
                step = {
                    0: '验收审核',
                    1: '验收审核',
                    2: '验收审核',
                    3: '验收审核',
                }
            }

            return step
        }
    },
    created() {
        this.init()
    },
    activated() {
        this.init()
    },
};
</script>
